import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Data } from '@angular/router';

@Component({
  selector: 'app-error404',
  templateUrl: './error404.component.html',
  styleUrls: ['./error404.component.scss']
})
export class Error404Component implements OnInit {

  message: string;

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {

    this.route.queryParams.subscribe((data: Data) => {
      if (data.e) {
        this.message = atob(data.e);
      } else {
        this.message = 'You requested ' + this.router.url + ', which could not be found.'
      }
    });

  }

}
